import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: 14px;

    overflow-y: scroll;
    height: 470px;

    &::-webkit-scrollbar { 
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
    }
`;

export const ContentInfor = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 10px;

    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    width: 100%;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    
`;

export const ContentHighlight = styled.div`
    border-radius: 4px;
    padding: 10px 10px;
    background-color: ${(props) => props.theme.colors.white};
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Icons = styled.div`
    width: 48px;
    height: 48px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    color: ${(props) => props.theme.colors.error};

    border-radius: 50px;
`;

export const InforDescription = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    &.title{
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    padding: 10px;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    
    span{
        color: ${(props) => props.theme.colors.error};
        margin-left: 3px;
    }
    &.infor{
        color: ${(props) => props.theme.colors.gray.gray_500};
    }
    &.sucess{
        color: ${(props) => props.theme.colors.success};
    }
    &.warning{
        color: ${(props) => props.theme.colors.warning};
    }
    &.error{
        color: ${(props) => props.theme.colors.error};
    }
`;

export const Section = styled.section`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const SectionHighlight = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    padding: 10px 10px;
    border-radius: 4px;
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const TextArea = styled.textarea`
    border: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    border-radius: 4px;
    resize: none;

    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const Title = styled.div`
    color: ${(props) => props.theme.colors.gray.gray_800};
    span{
        color: ${(props) => props.theme.colors.error};
        margin-left: 3px;
    }
`;